import { Button } from '@/components/button';
import HeadlineField from '@/components/customFields/HeadlineField';
import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import { HeadlineTag } from '@/components/customFields/types';
import Email from '@/public/icons/email.svg';
import Phone from '@/public/icons/telefon.svg';
import type { EntityContactStoryblok } from '@/types/component-types-sb';
import classNames from 'classnames';

import classes from './ContactCard.module.scss';

export const ContactCard: React.FC<{
  contact: EntityContactStoryblok;
  className?: string;
}> = ({ contact, className }) => {
  return (
    <>
      {contact && (
        <aside className={classNames(classes['contact-card'], className)}>
          <div className={classes['contact-card__content']}>
            <header className={classes['contact-card__header']}>
              {contact?.image && (
                <StoryblokImage
                  image={contact.image}
                  alt={contact.imageAltTag}
                  aspectRatio={1}
                  className={classes['contact-card__image']}
                />
              )}
              <HeadlineField
                className={classNames(classes['contact-card__title'], 'font-display-7')}
                tag={HeadlineTag.H3}
              >
                {contact.firstname} {contact.lastname}
              </HeadlineField>
            </header>
            {contact?.content && (
              <div className={classNames(classes['contact-card__body'], 'font-small')}>{contact.content}</div>
            )}
          </div>
          {(contact?.email || contact?.phone) && (
            <footer className={classes['contact-card__footer']}>
              {contact?.email && (
                <Button
                  link={`mailto:${contact.email}`}
                  label={contact.email}
                  title={contact.email}
                  variant="ctaFull"
                  data-theme="light"
                  startIcon={<Email aria-hidden={true} className={classes['contact-card__icon']} />}
                >
                  <span className={classes['contact-card__text']}>
                    <span className={classes['contact-card__text-scroll']}>{contact.email}</span>
                  </span>
                </Button>
              )}
              {contact?.phone && (
                <Button
                  link={`tel:${contact.phone}`}
                  label={contact.phone}
                  title={contact.phone}
                  variant="ctaFull"
                  data-theme="light"
                  startIcon={<Phone aria-hidden={true} className={classes['contact-card__icon']} />}
                >
                  <span className={classes['contact-card__text']}>
                    <span className={classes['contact-card__text-scroll']}>{contact.phone}</span>
                  </span>
                </Button>
              )}
            </footer>
          )}
        </aside>
      )}
    </>
  );
};

export default ContactCard;
